import { ColumnIconMap } from './column'

/**
 * All feature related icons in makyo
 */
export const appIconKeys = {
  database: 'data_table',
  table: 'table',
  tableSnapshot: 'photo_camera',
  tableQuery: 'database_search',
  tableSession: 'admin_panel_settings',
  tableUser: 'group',
  tableColumn: 'view_column',
  tableRow: 'table_rows',
  actionOutput: 'format_list_bulleted',
  uniqueId: 'vpn_key',
  globalVariable: 'globe',
  storage: 'storage',
  userTableAlert: 'person_alert',
  newsletterEmail: 'attach_email',
  columns: {
    ...ColumnIconMap,
  },
}
